import { GoChevronLeft, GoPlus } from 'react-icons/go';
import styles from './StoriesList.module.scss';
import { IWhatIfStory } from 'src/core/repo/whatif/types';
import { Tag } from 'antd';
import { useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import emptyImage from '@assets/images/ai4-plan.png';

interface Props {
  theme: 'day' | 'night';
  stories: IWhatIfStory[];
  setSelectedStory: (story: IWhatIfStory) => void;
  onBack: () => void;
}

const CHUNK = 5;

const StoriesList = ({ stories, onBack, setSelectedStory, theme }: Props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [visibleCount, setVisibleCount] = useState<number>(CHUNK);
  const hasMore = visibleCount < stories.length;

  const language = searchParams.get('lang');

  const visibleStories = useMemo(
    () => stories.slice(0, visibleCount),
    [stories, visibleCount],
  );

  const handleLoadMore = () => {
    if (hasMore) setVisibleCount((c) => Math.min(c + CHUNK, stories.length));
  };

  return (
    <div className="container">
      <div className={styles.description_wrapper}>
        <button onClick={onBack} className={styles.back_button}>
          <GoChevronLeft size={22} />
          <p>Back</p>
        </button>
        <h1 style={{ color: theme === 'night' ? '#fff' : '#000' }}>
          We found these <br />
          What if&apos;s for you
        </h1>
      </div>
      <div className={styles.storiesWrapper}>
        {visibleStories.map((story) => (
          <div
            onClick={() => setSelectedStory(story)}
            dir={story.dir}
            key={story.StoryID}
            className={styles.storyCard}>
            <div className={styles.storyCard_header}>
              <h2 className={styles.storyTitle}>{story.StoryTitle}</h2>
            </div>
            <div className={styles.storyImageWrapper}>
              <img
                style={{ objectFit: story.StoryImageURL ? 'cover' : 'contain' }}
                src={story.StoryImageURL ? story.StoryImageURL : emptyImage}
                alt={story.StoryTitle}
                className={styles.storyImage}
              />
            </div>
            <div>
              <p className={styles.storyText}>{story.StoryText}</p>
              <p className={styles.storyWhatIf}>
                <span>
                  {language === 'Persian' ? 'چی می شد اگر ؟' : 'What if ?'}
                </span>{' '}
                <br />
                {story.StoryWhatIf}
              </p>
            </div>
            <div
              className={styles.tags}
              dir={language === 'Persian' ? 'rtl' : 'ltr'}>
              <Tag color="#622E9D">{story.TrainingTopicTitle}</Tag>
              <Tag color="#622E9D">{story.Lang}</Tag>
              <Tag color="#622E9D">{story.AgeRangeTitle}</Tag>
            </div>
          </div>
        ))}
      </div>

      <div className={styles.actions}>
        {hasMore && (
          <button onClick={handleLoadMore} className={styles.back_button}>
            <GoPlus size={18} />
            <p>Show more</p>
          </button>
        )}
      </div>
    </div>
  );
};

export default StoriesList;
